import { FC } from "react";
import { IconButton, Stack, Text } from "@contentful/f36-components";
import { CheckCircleIcon, PlusCircleIcon } from "@contentful/f36-icons";
import tokens from "@contentful/f36-tokens";
import { useSDK } from "@contentful/react-apps-toolkit";
import { useTranslationContext } from "../context";

export const GlossaryIndicator: FC = () => {
    const sdk = useSDK();
    const {
        state: { glossary },
    } = useTranslationContext();

    return (
        <Stack spacing="none">
            <IconButton
                aria-label="Open app configuration"
                size="small"
                icon={
                    glossary ? (
                        <CheckCircleIcon style={{ fill: tokens.purple500 }} size="tiny" />
                    ) : (
                        <PlusCircleIcon style={{ fill: tokens.purple400 }} size="tiny" />
                    )
                }
                withTooltip
                tooltipProps={{
                    content: "Add or select a glossary",
                }}
                onClick={sdk.navigator.openAppConfig}
            />
            <Text
                fontSize="fontSizeM"
                fontColor={glossary ? "purple500" : "purple400"}
                fontWeight="fontWeightMedium">
                {glossary ? `Using ${glossary.name}` : "No glossary selected"}
            </Text>
        </Stack>
    );
};
